import { render, staticRenderFns } from "./ViewShift.vue?vue&type=template&id=5a635d6a"
import script from "./ViewShift.vue?vue&type=script&lang=js"
export * from "./ViewShift.vue?vue&type=script&lang=js"
import style0 from "./View.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports